import React, { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { SignInForm } from 'features/auth';

import './SignIn.scss';

type Props = {
  isAdmin: boolean;
};

const SignIn = ({ isAdmin }: Props) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isAdmin) {
      navigate('/');
    }
  }, [navigate, isAdmin]);

  return (
    <div className="sign-in">
      <SignInForm />
    </div>
  );
};

export default SignIn;
